import React from "react";

import { Icon } from "@chakra-ui/react";
import { MdBarChart, MdPerson, MdLock, MdOutlineDashboard } from "react-icons/md";
import { FaRegUser, FaFileInvoice, FaHandHoldingUsd } from "react-icons/fa";
import { TbReport } from "react-icons/tb";

// Admin Imports
import Profile from "views/admin/profile";
import DataTables from "views/admin/dataTables";
import AdminOverview from "views/admin/overview";
import UserManagement from "views/admin/userManagement";
import TermsManagement from "views/admin/termsManagement";
import InvoiceManagement from "views/admin/invoiceManagement";
import Funding from "views/admin/funding";
import Icons from "assets/img/icons/icons";

// Auth Imports
import SignInCentered from "views/auth/signIn";
import ForgotPassword from "views/auth/forgotPassword";
import Register from "views/auth/register";

// User Imports
import UserOverview from "views/user/overview";
import Invoices from "views/user/invoices";
import UserProfile from "views/user/profile";

const routes = [
  // {
  //   name: "Profile",
  //   layout: "/admin",
  //   path: "/profile",
  //   icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
  //   component: Profile,
  //   requiredRole: "ADMIN",
  // },
  // {
  //   name: "Data Tables",
  //   layout: "/admin",
  //   icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
  //   path: "/data-tables",
  //   component: DataTables,
  //   requiredRole: "ADMIN",
  // },
  // {
  //   name: "Overview",
  //   layout: "/admin",
  //   icon: <Icons.DashboardIcon />,
  //   path: "/overview",
  //   component: AdminOverview,
  //   requiredRole: "ADMIN",
  // },
  {
    name: "User Management",
    layout: "/admin",
    icon: <Icons.UserIcon />,
    path: "/user-management",
    component: UserManagement,
    requiredRole: "ADMIN",
  },
  {
    name: "Terms Management",
    layout: "/admin",
    icon: <Icons.TermsIcon />,
    path: "/terms-management",
    component: TermsManagement,
    requiredRole: "ADMIN",
  },
  {
    name: "Invoice Management",
    layout: "/admin",
    icon: <Icons.InvoiceIcon />,
    path: "/invoice-management",
    component: InvoiceManagement,
    requiredRole: "ADMIN",
  },
  {
    name: "Funding",
    layout: "/admin",
    icon: <Icons.FundIcon />,
    path: "/funding",
    component: Funding,
    requiredRole: "ADMIN",
  },
  {
    name: "User Profile",
    layout: "/user",
    path: "/profile",
    icon: <Icons.UserIcon />,
    component: UserProfile,
    requiredRole: "USER",
  },
  {
    name: "Invoices",
    layout: "/user",
    path: "/invoices",
    icon: <Icons.InvoiceIcon />,
    component: Invoices,
    requiredRole: "USER",
  },
  // {
  //   name: "Overview",
  //   layout: "/user",
  //   path: "/overview",
  //   icon: <Icons.DashboardIcon />,
  //   component: UserOverview,
  //   requiredRole: "USER",
  // },
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignInCentered,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "/forgot-password",
    component: ForgotPassword,
  },
  {
    name: "Register",
    layout: "/auth",
    path: "/register",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: Register,
  },
];

export default routes;
